import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useFlags } from 'launchdarkly-react-client-sdk';

const WAITLIST_CLOSED_MESSAGE =
  'The waitlist at this property is closed. Please contact the property for more information.';
const APPLICATIONS_CLOSED_MESSAGE =
  'The property is not accepting applications at this time. Please contact the property for more information.';

export function useFormProps() {
  const { configs, affordableWaitlist } = useContext(AppContext);
  const {
    affordableWaitlist: affordableWaitlistFlag,
    acceptingOnlineApplications: onlineApplicationsFlag,
  } = useFlags();
  let disabled = false;
  let disabledMessage = null;

  const affordableWaitlistClose =
    affordableWaitlistFlag &&
    affordableWaitlist?.enabled &&
    affordableWaitlist.status === 'CLOSED';

  if (onlineApplicationsFlag) {
    if (configs.isApplicationsOpen) {
      if (affordableWaitlistClose) {
        disabled = true;
        disabledMessage = WAITLIST_CLOSED_MESSAGE;
      }
    } else {
      disabled = true;
      disabledMessage = APPLICATIONS_CLOSED_MESSAGE;
    }
  } else if (affordableWaitlistClose) {
    disabled = true;
    disabledMessage = WAITLIST_CLOSED_MESSAGE;
  }

  return {
    disabled,
    disabledMessage,
  };
}
